import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { CustomSortableTable, DashboardLayout, ReadOnlyBlock } from '@blumtechgroup/blum-react-core-components';
import { useQuery } from '@apollo/client';
import { selectOrganisationLicensesInitQuery, LicenseType, Location, LicenseTypeAssignment } from './queries';

type UrlParams = {
  license_type_id: string;
};

interface ViewOrganisationLicensesPageState {
  licenseType: LicenseType;
  locations: Location[];
  licenseTypeAssignment: LicenseTypeAssignment;
}

const ViewOrganisationLicenses = (): React.ReactElement => {
  const navigate = useNavigate();

  const { license_type_id } = useParams<UrlParams>();

  const [pageState, setPageState] = useState<ViewOrganisationLicensesPageState>({
    licenseType: {
      name: '',
    },
    locations: [],
    licenseTypeAssignment: {
      count: 0,
    },
  });

  const { data: organisationLicensesData } = useQuery(selectOrganisationLicensesInitQuery(license_type_id!), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (organisationLicensesData && organisationLicensesData.organisation_license_type_assignments?.length) {
      setPageState({
        licenseType: organisationLicensesData.license_types_by_pk,
        locations: organisationLicensesData.locations,
        licenseTypeAssignment: organisationLicensesData.organisation_license_type_assignments[0],
      });
    }
  }, [organisationLicensesData]);

  const handleEdit = (locationId: string) => {
    navigate(`/org/locations/${locationId}/edit`);
  };

  const handleView = (locationId: string) => {
    navigate(`/org/license-types/${license_type_id}/locations/${locationId}`);
  };

  const rows = pageState.locations.map((item) => {
    return {
      key: item.id,
      actions: [
        {
          label: 'Edit',
          onClick: () => handleEdit(item.id),
        },
        {
          label: 'View',
          onClick: () => handleView(item.id),
        },
      ],
      columns: [
        {
          key: 'name',
          label: item.name,
        },
        {
          key: 'count',
          label: item.license_type_assignments.length ? item.license_type_assignments[0].count : 0,
        },
      ],
    };
  });

  return (
    <DashboardLayout breadcrumbs={[{ label: 'Home', link: '/org/home' }, { label: 'License Types', link: '/org/license-types' }, { label: pageState.licenseType.name }]}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ReadOnlyBlock
            gridSize={4}
            items={[
              {
                label: 'Name',
                components: [
                  <Typography variant="h5" component="span">
                    {pageState.licenseType.name}
                  </Typography>,
                ],
              },
              {
                label: 'Available licenses',
                value: pageState.licenseTypeAssignment.count.toString(),
              },
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomSortableTable
            searchable={['name']}
            title={'Hospitals'}
            counter={'filtered'}
            headers={[
              {
                key: 'name',
                label: 'Name',
              },
              {
                key: 'count',
                label: 'Count',
              },
            ]}
            rows={rows}
          />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default ViewOrganisationLicenses;
